export default "__VITE_PUBLIC_ASSET__dee48fcb__"